<template>
  <el-header>
    <div class="logo">
      <!-- <img src="../assets/img/logo_white.png" alt class="logo-img" /> -->
       <img src="../assets/img/logo2026.png" alt class="logo-img" />
    </div>
    <div class="header-right">
      <el-menu
      :default-active="currentPath"
      class="nav-menu"
      mode="horizontal"
      @select="handleSelect"
      :router="false"
      text-color="#000"
      active-text-color="#005a62"
    >
      <!-- 按原始顺序遍历所有一级菜单 -->
      <template v-for="(item, index) in menuData">
        <!-- 没有子菜单的一级菜单 -->
        <el-menu-item 
          v-if="!item.children || item.children.length === 0"
          :key="`menu-item-${index}`"
          :index="item.path"
          @click="handleMenuClick(item, 1)"
        >
          {{ item.name }}
        </el-menu-item>
        
        <!-- 有子菜单的一级菜单 -->
        <el-submenu 
          v-else
          :key="`menu-submenu-${index}`"
          :index="item.id.toString()"
          popper-class="custom-submenu"
        >
          <template #title>
            <span class="submenu-title-clickable" @click.stop="handleMenuClick(item, 1, item)">{{ item.name }}</span>
          </template>
          
          <!-- 按原始顺序遍历二级菜单 -->
          <template v-for="(secondLevel, secondIndex) in item.children">
            <!-- 没有三级菜单的二级菜单 -->
            <el-menu-item 
              v-if="!secondLevel.children || secondLevel.children.length === 0"
              :key="`second-item-${index}-${secondIndex}`"
              :index="secondLevel.path"
              @click="handleMenuClick(secondLevel, 2, item)"
            >
              {{ secondLevel.name }}
            </el-menu-item>
            
            <!-- 有三级菜单的二级菜单 -->
            <el-submenu 
              v-else
              :key="`second-submenu-${index}-${secondIndex}`"
              :index="`${item.id}-${secondLevel.id}`"
              popper-class="custom-submenu-third"
            >
              <template #title>
                <span class="submenu-title-clickable" @click.stop="handleMenuClick(secondLevel, 2, item)">{{ secondLevel.name }}</span>
              </template>
              
              <!-- 三级菜单 -->
              <el-menu-item 
                v-for="thirdLevel in secondLevel.children" 
                :key="thirdLevel.id"
                :index="thirdLevel.path"
                @click="handleMenuClick(thirdLevel, 3, item, secondLevel)"
              >
                {{ thirdLevel.name }}
              </el-menu-item>
            </el-submenu>
          </template>
        </el-submenu>
      </template>
    </el-menu>
    <div @click="$router.push('/search')" style="cursor: pointer;"><i class="el-icon-search"></i></div>

    </div>
    
  </el-header>
</template>

<script>
import { getDefaultMenuData } from '../services/menuService'

export default {
  name: 'Header',
  data() {
    return {
      menuData: [], // 从API获取的菜单数据
      currentPath: '/', // 当前路径
      loading: false // 加载状态
    };
  },
  mounted() {
    this.loadMenuData();
    this.updateCurrentPath();
  },
  watch: {
    '$route'(to) {
      this.currentPath = to.path;
    }
  },
  methods: {
    // 转换API响应数据为菜单结构
    transformMenuData(apiData, parentPath = '') {
      if (!Array.isArray(apiData)) {
        return []
      }

      return apiData.map(item => {
        const currentPath = this.buildPath(item, parentPath)
        const menuItem = {
          id: item.id,
          name: item.name,
          path: currentPath,
          linkUrl: item.linkUrl,
          icon: item.icon,
          bannerUrl: this.getBannerUrl(item),
          hasDetail: item.hasDetail,
          children: item.children ? this.transformMenuData(item.children, currentPath) : []
        }
        return menuItem
      })
    },

    // 根据规则构建路径
    buildPath(item, parentPath) {
      // 规则：
      // 1) 有 url -> 直接返回 url（一级都会有）
      // 2) 无 url 且有子级 -> 继承父级路径，不追加 id
      // 3) 无 url 且无子级 -> 父级路径 + '/detail/' + 自己的 id
      if (item && item.linkUrl) {
        return item.linkUrl
      }
      const hasChildren = Array.isArray(item && item.children) && item.children.length > 0
      const base = parentPath || ''
      if (hasChildren) {
        return base || '/'
      }
      return this.joinPath(base || '/', 'detail', String(item.id))
    },

    // 路径拼接，确保只有一个斜杠（支持多段）
    joinPath(...segments) {
      const cleaned = segments
        .filter(Boolean)
        .map((seg, idx) => {
          if (idx === 0) return seg.replace(/\/$/, '') || '/'
          return seg.replace(/^\//, '').replace(/\/$/, '')
        })
      let result = cleaned.join('/').replace(/\/\//g, '/')
      if (!result.startsWith('/')) result = `/${result}`
      return result
    },

    // 获取横幅图片URL
    getBannerUrl(item) {
      if (item.carousels && item.carousels.length > 0) {
        return item.carousels[0].imageUrl
      }
      return null
    },

    // 加载菜单数据
    async loadMenuData() {
      this.loading = true;
      try {
        // 使用this.$http获取菜单数据
        const response = await this.$http.get('/api/menus/tree');
        if (response.data && response.data.success && response.data.data) {
          this.menuData = this.transformMenuData(response.data.data);
        } else {
          this.menuData = [];
        }
        console.log(this.menuData, 999)
      } catch (error) {
        console.error('加载菜单数据失败:', error);
        // 使用默认菜单数据作为fallback
        this.menuData = getDefaultMenuData();
      } finally {
        this.loading = false;
      }
      console.log(this.menuData, 999)
    },
    
    // 更新当前路径
    updateCurrentPath() {
      this.currentPath = this.$route.path;
    },
    
    // 菜单选择事件
    handleSelect(key) {
      console.log('Menu selected:', key);
      this.$emit('menu-select', key);
    },
    
    // 处理菜单点击事件（通用规则：hasDetail 走 detail，否则进入 base/category）
    handleMenuClick(item, level, topItem, parentItem = null) {
      const resolvedPath = (item && item.path) || item.linkUrl
      if (!resolvedPath) return

      // 外部链接：新标签页打开
      if ((resolvedPath || '').startsWith('http')) {
        window.open(resolvedPath, '_blank')
        return
      }

      const base = this.getBaseFromTop(topItem || item)

      // 非模块型菜单（无法识别 base）直接按路径处理
      if (!base || !['product','platform','news'].includes(base)) {
        this.$router.push(resolvedPath)
        return
      }

      // 顶级菜单的特殊规则：顶级 hasDetail=true 时，默认跳到第一个子菜单；再根据子菜单 hasDetail 决策
      if (
        level === 1 && item && item.hasDetail === true && Array.isArray(item.children) && item.children.length > 0
      ) {
        const firstChild = item.children[0]
        if (firstChild) {
          if (firstChild.hasDetail === true) {
            const categoryId = item.id || firstChild.id
            this.$router.push({ name: `${base}-detail`, params: { categoryId: String(categoryId), productId: String(firstChild.id) } })
          } else {
            this.$router.push({ name: `${base}-category`, params: { categoryId: String(firstChild.id) } })
          }
          return
        }
      }

      // 一级菜单：常规进入 base 根（让页面自行决定默认分类）
      if (level === 1) {
        const basePath = (item && (item.path || item.linkUrl)) || '/'
        if (base && ['product','platform','news'].includes(base)) {
          this.$router.push({ name: base, query: { menuId: String(item.id) } })
        } else {
          const fallback = (basePath && basePath !== '/') ? basePath : '/product'
          this.$router.push({ path: fallback, query: { menuId: String(item.id) } })
        }
        return
      }

      // 二级：hasDetail 走 detail，否则进入分类
      if (level === 2) {
        if (item && item.hasDetail === true) {
          const categoryId = (parentItem && parentItem.id) ? parentItem.id : item.id
          this.$router.push({ name: `${base}-detail`, params: { categoryId: String(categoryId), productId: String(item.id) } })
        } else {
          this.$router.push({ name: `${base}-category`, params: { categoryId: String(item.id) } })
        }
        return
      }

      // 三级及以下：hasDetail 走 detail，否则进入分类（categoryId 用父级回退）
      if (item && item.hasDetail === true) {
        const categoryId = (parentItem && parentItem.id) ? parentItem.id : item.id
        const productId = item.id
        this.$router.push({ name: `${base}-detail`, params: { categoryId: String(categoryId), productId: String(productId) } })
      } else {
        const categoryId = item.id
        this.$router.push({ name: `${base}-category`, params: { categoryId: String(categoryId) } })
      }
    },

    // 从顶层菜单项推断模块 base（product/platform/news）
    getBaseFromTop(topItem) {
      const basePath = (topItem && (topItem.path || topItem.linkUrl)) || ''
      if (typeof basePath !== 'string') return ''
      if (basePath.startsWith('/product')) return 'product'
      if (basePath.startsWith('/platform')) return 'platform'
      if (basePath.startsWith('/news')) return 'news'
      return ''
    }
  }
};
</script>

<style lang="scss" scoped>
.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 4rem !important;
  padding-right: 14rem !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  color: #000;
  background-color: #fff !important;
  height: 6.25rem !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .logo {
    width: 15rem;

    .logo-img {
      width: 100%;
      content: url("../assets/img/logo2026.png");
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    .el-icon-search{
      font-size: 1.25rem;
    }
  }

  .nav-menu {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    // background: transparent !important;
    padding-right: 2rem;

    :deep(.el-menu-item) {
      font-size: 1.5rem;
      color: #000;
      border-bottom: 0 !important;
      height: 100%;
      line-height: 6.25rem;
      padding: 0 1.5rem;

      &:hover {
        color: #005a62 !important;
        background-color: rgba(0, 90, 98, 0.1) !important;
      }

      &.is-active {
        color: #005a62 !important;
        border-color: #005a62 !important;
        font-weight: 600;
      }
    }

    :deep(.el-submenu__title) {
        font-size: 1.5rem;
        // background: red !important;
        border-bottom: 0 !important;
        height: 100%;
        line-height: 6.25rem;
        padding: 0 1.5rem;

        &:hover {
          color: #005a62 !important;
          background-color: rgba(0, 90, 98, 0.1) !important;
        }
      }

      &.is-active .el-submenu__title {
        color: #005a62 !important;
        border-color: #005a62 !important;
        font-weight: 600;
      }
  }
}

:deep(.el-submenu__title) {
  border-bottom: 1px solid #f0f0f0 !important;
}

// 让整个子菜单标题区域都可点击
.submenu-title-clickable {
  display: inline-block;
  height: 100%;
  cursor: pointer;
}

// 三级菜单样式
:deep(.custom-submenu-third) {
  .el-menu {
    background: #fff !important;
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    padding: 0.5rem 0;
    min-width: 200px;

    .el-menu-item {
      height: auto;
      line-height: 1.5;
      padding: 0.5rem 1rem;
      color: #666;
      font-size: 1rem;
      background: #fff !important;
      border-bottom: 1px solid #f0f0f0;

      &:hover {
        background-color: rgba(0, 90, 98, 0.08) !important;
        color: #005a62 !important;
      }

      // &:last-child {
      //   border-bottom: none;
      // }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .el-header {
    padding-right: 50px !important;

    .nav-menu {
      :deep(.el-menu-item),
      :deep(.el-submenu .el-submenu__title) {
        padding: 0 1rem;
        font-size: 1rem;
      }
    }
  }
}

@media (max-width: 768px) {
  .el-header {
    padding-right: 20px !important;
    height: 5rem !important;

    .logo {
      width: 12rem;
    }

    .nav-menu {
      :deep(.el-menu-item),
      :deep(.el-submenu .el-submenu__title) {
        padding: 0 0.5rem;
        font-size: 0.9rem;
        line-height: 5rem;
      }
    }
  }
}
</style>
